<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Membership Rate Comparison (default: 3 data columns)</h1>
        <aha-component title="">
            <membership-rate-comparison :table-data="demoDataMembershipRateComparison">
                <template slot="postTableContent">
                    <div class="flex-table__content-group">
                        <div 
                            class="row">
                            <div class="col-12">
                                <h4 class="rate-comparison__disclaimer-title">1Title here is optional</h4>
                            </div>
                        </div>

                        <div 
                            class="row">
                            <div class="col-12 rate-comparison__disclaimer-content">
                                <p>*Verification of Student/Trainee status is required. Please see "Membership Discounts" below for details.<br/><strong>Gold Package</strong> includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)</p>
                            </div>
                        </div>
                    </div>
                </template>
            </membership-rate-comparison>
        </aha-component>

        <h1 class="page-heading mb-0 mt-5">Membership Rate Comparison (2 data columns)</h1>
        <aha-component title="">
            <membership-rate-comparison :table-data="demoDataMembershipRateComparison2datacolumns">
                <template slot="postTableContent">
                    <div class="flex-table__content-group">
                        <div 
                            class="row">
                            <div class="col-12">
                                <h4 class="rate-comparison__disclaimer-title">2Title here is optional</h4>
                            </div>
                        </div>

                        <div 
                            class="row">
                            <div class="col-12 rate-comparison__disclaimer-content">
                                <p>*Verification of Student/Trainee status is required. Please see "Membership Discounts" below for details.<br/><strong>Gold Package</strong> includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)</p>
                            </div>
                        </div>
                    </div>
                </template>
            </membership-rate-comparison>
        </aha-component>

        <h1 class="page-heading mb-0 mt-5">Membership Rate Comparison (1 data columns)</h1>
        <aha-component title="">
            <membership-rate-comparison :table-data="demoDataMembershipRateComparison1datacolumn">
                <template slot="postTableContent">
                    <div class="flex-table__content-group">
                        <div 
                            class="row">
                            <div class="col-12">
                                <h4 class="rate-comparison__disclaimer-title">3Title here is optional</h4>
                            </div>
                        </div>

                        <div 
                            class="row">
                            <div class="col-12 rate-comparison__disclaimer-content">
                                <p>*Verification of Student/Trainee status is required. Please see "Membership Discounts" below for details.<br/><strong>Gold Package</strong> includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)</p>
                            </div>
                        </div>
                    </div>
                </template>
            </membership-rate-comparison>
        </aha-component>

        <h1 class="page-heading mb-0 mt-5">Membership Rate Comparison (1 data columns, no gold data)</h1>
        <aha-component title="">
            <membership-rate-comparison :table-data="demoDataMembershipRateComparison1datacolumnNoGold">
                <template slot="postTableContent">
                    <div class="flex-table__content-group">
                        <div 
                            class="row">
                            <div class="col-12">
                                <h4 class="rate-comparison__disclaimer-title">4Title here is optional</h4>
                            </div>
                        </div>

                        <div 
                            class="row">
                            <div class="col-12 rate-comparison__disclaimer-content">
                                <p>*Verification of Student/Trainee status is required. Please see "Membership Discounts" below for details.<br/><strong>Gold Package</strong> includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)</p>
                            </div>
                        </div>
                    </div>
                </template>
            </membership-rate-comparison>
        </aha-component>

        <h1 class="page-heading mb-0">Membership Rate Comparison</h1>
        <aha-component title="">
            <!-- Dev note: The following line is what you 
                    need for implimentation.
                    
                    Note the 'tables' prop.  This is where the 
                    data is read into the actual component.
                    
                    This component can support 1 or many sets of
                    data, although it's really meant for 2.
                    -->
            <daily-rate-comparison :tables="demoDataDailyRateComparison" />
        </aha-component>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                demoDataMembershipRateComparison: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership'
                    },
                    rateText: [
                        {
                            title: 'Early Rate',
                            date: 'Oct. 9 - Dec. 31',
                        },
                        {
                            title: 'Advanced Rate',
                            date: 'Jan. 1 - Jan. 28',
                        },
                        {
                            title: 'Standard Rate',
                            date: 'Jan. 29 - Feb. 19',
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rates: [
                                {
                                    normal: '$500',
                                    gold: '$850'
                                },
                                {
                                    normal: '$600',
                                    gold: '$950'
                                },
                                {
                                    normal: '$700',
                                    gold: '$1,050'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                     normal: '$400',
                                    gold: '$750'
                                },
                                {
                                    normal: '$500',
                                    gold: '$850'
                                },
                                {
                                    normal: '$600',
                                    gold: '$950'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                },
                                {
                                    normal: '$1,200',
                                    gold: '$1,700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75',
                                    gold: '$375'
                                },
                                {
                                    normal: '$1750',
                                    gold: '$475'
                                },
                                {
                                    normal: '$275',
                                    gold: '$575'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300',
                                    gold: '$600'
                                },
                                {
                                    normal: '$400',
                                    gold: '$700'
                                },
                                {
                                    normal: '$500',
                                    gold: '$800'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                            rates: [
                                {
                                    normal: '$200',
                                    gold: '$500'
                                },
                                {
                                    normal: '$300',
                                    gold: '$600'
                                },
                                {
                                    normal: '$400',
                                    gold: '$700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                },
                                {
                                    normal: '$1,200',
                                    gold: '$1,700'
                                }
                            ]
                        }
                    ],
                },
                // 2 data column here
                demoDataMembershipRateComparison2datacolumns: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership'
                    },
                    rateText: [
                        {
                            title: 'Early Rate',
                            date: 'Oct. 9 - Dec. 31',
                        },
                        {
                            title: 'Advanced Rate',
                            date: 'Jan. 1 - Jan. 28',
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rates: [
                                {
                                    normal: '$500',
                                    gold: '$850'
                                },
                                {
                                    normal: '$600',
                                    gold: '$950'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                     normal: '$400',
                                    gold: '$750'
                                },
                                {
                                    normal: '$500',
                                    gold: '$850'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75',
                                    gold: '$375'
                                },
                                {
                                    normal: '$1750',
                                    gold: '$475'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300',
                                    gold: '$600'
                                },
                                {
                                    normal: '$400',
                                    gold: '$700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                            rates: [
                                {
                                    normal: '$200',
                                    gold: '$500'
                                },
                                {
                                    normal: '$300',
                                    gold: '$600'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                }
                            ]
                        }
                    ],
                },
                // 1 data column here
                demoDataMembershipRateComparison1datacolumn: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership'
                    },
                    rateText: [
                        {
                            title: 'Early Rate',
                            date: 'Oct. 9 - Dec. 31',
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rates: [
                                {
                                    normal: '$500',
                                    gold: '$850'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                     normal: '$400',
                                    gold: '$750'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75',
                                    gold: '$375'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300',
                                    gold: '$600'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                            rates: [
                                {
                                    normal: '$200',
                                    gold: '$500'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                }
                            ]
                        }
                    ],
                },
                // 1 data column here - No Gold
                demoDataMembershipRateComparison1datacolumnNoGold: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership'
                    },
                    rateText: [
                        {
                            title: 'Early Rate',
                            date: 'Oct. 9 - Dec. 31',
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rates: [
                                {
                                    normal: '$500'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member and a bunch of other text to make it really long and ensure it\'s going to wrap in order to test out the way the words flow',
                            rates: [
                                {
                                    normal: '$400'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900,000'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75,000'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                            rates: [
                                {
                                    normal: '$2,000,000'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900'
                                }
                            ]
                        }
                    ],
                },
                demoDataWithoutGoldPricing: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership (no gold)'
                    },
                    rateText: [
                        {
                            title: 'Early Rate'
                        },
                        {
                            title: 'Advanced Rate'
                        },
                        {
                            title: 'Standard Rate'
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis & Thrombectomy',
                            rates: [
                                {
                                    normal: '$500'
                                },
                                {
                                    normal: '$600'
                                },
                                {
                                    normal: '$700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                    normal: '$400'
                                },
                                {
                                    normal: '$500'
                                },
                                {
                                    normal: '$600'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900'
                                },
                                {
                                    normal: '$1,000'
                                },
                                {
                                    normal: '$1,200'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75'
                                },
                                {
                                    normal: '$1750'
                                },
                                {
                                    normal: '$275'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300'
                                },
                                {
                                    normal: '$400'
                                },
                                {
                                    normal: '$500'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rates: [
                                {
                                    normal: '$200'
                                },
                                {
                                    normal: '$300'
                                },
                                {
                                    normal: '$400'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900'                                },
                                {
                                    normal: '$1,000'                                },
                                {
                                    normal: '$1,200'                                }
                            ]
                        }
                    ],
                },
                demoDataDailyRateComparison: [
                    // Demo Data Set 1
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Wednesday & Thursday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$275'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$375'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$475'
                            }
                        ]
                    },
                    // Demo Data Set 2
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Friday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$200'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$300'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$400'
                           }
                        ]
                    },
                    // Demo Data Set 3
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Friday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$200'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$300'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$400'
                           }
                        ]
                    },
                    // Demo Data Set 4
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Friday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$200'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$300'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$400'
                           }
                        ]
                    },
                    // Demo Data Set 5
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Friday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$200'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$300'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$400'
                           }
                        ]
                    }
                ]
            }
        }
    }
</script>




// WEBPACK FOOTER //
// demo/pages/layouts/phd-membership-tables-example.vue